import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs';
import { IBcContest, permissions } from '../../../models/BcContest';
import { AppDatePipe } from '../../../pipes/date.pipe';

import { AppService } from '../../../services/app.service';
import { BcContestService } from '../../../services/bc-contest.service';
import { BcContestApplicationsComponent } from '../applications/bc-contest-applications.component';
import { bcState } from '../shared';
import { BcContestSubmitComponent } from '../submit/bc-contest-submit.component';

@Component({
    selector: 'app-bc-contest-view',
    templateUrl: './bc-contest-view.component.html',
    styleUrls: ['../bc-contest.scss']
})
export class BcContestViewComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: BcContestService,
        private route: ActivatedRoute,
        private modal: NgbModal,
        private datePipe: AppDatePipe
    ) { }

    item: IBcContest;

    courseKey = 0;
    studentKey = 0;

    canEdit: boolean;

    private id: number;

    ngOnInit() {
        this.canEdit = this.app.currentUser.hasRight(permissions.edit);

        this.id = +this.route.snapshot.params['id'];

        if (bcState.shouldSync(this.id)) {
            this.app.addLoading(forkJoin(
                this.service.syncCourses(this.id),
                this.service.syncStudents(this.id)
            )).subscribe(() => {
                this.load();
            });
        } else {
            this.load();
        }
    }

    syncCourses() {
        this.app.addLoading(this.service.syncCourses(this.id)).subscribe(() => {
            bcState.clearCourses();
            this.courseKey++;
            this.app.notify('bcContest_courseSyncSuccess');
        });
    }

    syncStudents() {
        this.app.addLoading(this.service.syncStudents(this.id)).subscribe(() => {
            this.studentKey++;
            this.app.notify('bcContest_studentSyncSuccess');
        });
    }

    publish() {
        this.app.confirm({
            title: this.app.translate('bcContest_publish'),
            text: this.app.translate('bcContest_publishConfirm')
                .replace('{{openedFrom}}', this.datePipe.transform(this.item.OpenedFrom, 'datetime'))
                .replace('{{openedTo}}', this.datePipe.transform(this.item.OpenedTo, 'datetime'))
                .replace('{{visibleFrom}}', this.datePipe.transform(this.item.ResultsVisibleFrom, 'datetime'))
                .replace('{{visibleTo}}', this.datePipe.transform(this.item.ResultsVisibleTo, 'datetime')),
            okText: this.app.translate('continue')
        }, ok => {
            if (ok) {
                this.app.addLoading(this.service.publish(this.id)).subscribe(() => {
                    this.load();
                    this.app.notify('bcContest_publishSuccess');
                });
            }
        });
    }

    calculate() {
        this.app.confirm({
            title: this.app.translate('bcContest_calculate'),
            text: this.app.translate('bcContest_calculateConfirm'),
            okText: this.app.translate('continue')
        }, ok => {
            if (ok) {
                this.app.addLoading(this.service.calculate(this.id)).subscribe(() => {
                    bcState.clearApplications();
                    this.app.notify('bcContest_calculateSuccess');
                });
            }
        });
    }

    submit() {
        const ref = this.modal.open(BcContestSubmitComponent, { size: 'md' });

        ref.componentInstance.contestId = this.id;

        ref.closed.subscribe((success: boolean) => {
            bcState.clearApplications();
            this.load();
        });
    }

    openFailedApplications() {
        const ref = this.modal.open(BcContestApplicationsComponent, { size: 'lg' });

        ref.componentInstance.data = {
            contestId: this.id,
            hasError: true
        };
    }

    apply() {
        window.open(this.app.normalizeRoute('/bc-contests/apply'), '_blank');
    }

    private load() {
        this.app.addLoading(this.service.getById(this.id)).subscribe(data => {
            this.item = data;
            bcState.setContest(data);
        });
    }
}
